import { grayColor } from 'assets/jss/material-dashboard-pro-react.js';

import buttonStyle from 'assets/jss/material-dashboard-pro-react/components/buttonStyle.js';

const sweetAlertStyle = {
	cardTitle: {
		marginTop: '0',
		marginBottom: '3px',
		color: grayColor[2],
		fontSize: '18px',
	},
	center: {
		textAlign: 'center',
	},
	right: {
		textAlign: 'right',
	},
	left: {
		textAlign: 'left',
	},
	dialogButton: {
		fontWeight: '500',
		willChange: 'auto',
	},
	dialogConfirmButton: {
		'&:hover': {
			boxShadow:
				'0 2px 2px 0 rgba(153, 153, 153, 0.14), 0 3px 1px -2px rgba(153, 153, 153, 0.2), 0 1px 5px 0 rgba(153, 153, 153, 0.12) !important',
			backgroundColor: '#4caf50 !important',
		},
	},
	...buttonStyle,
};

export default sweetAlertStyle;
